export default __webpack_public_path__ + "static/email-04b39c7adff06ec7fa94ac8501fdcded.svg";